'use strict';

var R = require('ramda');
var Axios = require('axios');
var Cheerio = require('cheerio');

// Function-first
function maybeMap(f, a) {
    if (!R.isNil(a)) {
        return f(a);
    }
}

function attrContent(el) {
    return el.attr('content');
}

function promiseEmbedInfoForURL(url) {
    return Axios.get(url).then(function (_ref) {
        var data = _ref.data;

        var find = Cheerio.load(data);
        var twitterPlayerURL = maybeMap(attrContent, find('meta[name="twitter:player"]'));
        if (twitterPlayerURL) {
            return {
                url: twitterPlayerURL,
                width: maybeMap(attrContent, find('meta[name="twitter:player:width"]')),
                height: maybeMap(attrContent, find('meta[name="twitter:player:height"]'))
            };
        }
    });
}

module.exports = promiseEmbedInfoForURL;


//////////////////
// WEBPACK FOOTER
// ./~/lokum/lib/promiseEmbedInfoForURL.js
// module id = 353
// module chunks = 0